import { render, staticRenderFns } from "./SanityGrid.vue?vue&type=template&id=ac140578"
import script from "./SanityGrid.vue?vue&type=script&lang=js"
export * from "./SanityGrid.vue?vue&type=script&lang=js"
import style0 from "./SanityGrid.vue?vue&type=style&index=0&id=ac140578&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports